import { DEFAULT_AVATAR } from '../../shared/avatars';
export function UserAvatar({ src, size = 34 }: { src?: string; size?: number }) {
  return (
    <img
      className="user-avatar"
      src={src || DEFAULT_AVATAR}
      alt=""
      width={size}
      height={size}
      onError={(e) => {
        if (!e.currentTarget.src.endsWith(DEFAULT_AVATAR)) e.currentTarget.src = DEFAULT_AVATAR;
      }}
    />
  );
}
